import React from 'react';
import clsx from 'clsx';
import { IProps } from './ImageBlock.interface';
import './ImageBlock.styles.css';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';
import Image from '@/elements/Image/Image.component';
import Text from '@/elements/Text/Text.component';

/**
 * @component ImageBlock
 * @description A block component that displays an image with an optional caption below it.
 * @param {IProps} props - The component props.
 * @returns {React.ReactElement} - The rendered component.
 */
const ImageBlock: React.FC<IProps> = ({
    className,
    image,
    caption,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper className={clsx('imageBlock', className)} {...blockWrapperProps}>
            <ContentWrapper>
                <ContentColumn>
                    {image && <Image {...image} rounded={true} />}
                    {caption && (
                        <Text className="imageBlock__caption" html={caption} />
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export { ImageBlock };
